module.exports = __webpack_public_path__ + "static/media/andrew-moroz-resume.dc3fcb33.pdf";